/**
 * Object storage key builders. Every key in the bucket comes from here so purge/delete can reason by prefix.
 *   originals/{userId}/{photoId}.{ext}
 *   derivatives/{photoId}/{variant}.jpg          variant = thumb | preview | export-{hash}
 *   exports/{albumId}/{jobId}/album.pdf|cover.pdf
 *   flipbook/{albumId}/{jobId}/{n}.jpg
 *   fonts/{userId}/{fontId}.{ext}
 */
export type DerivativeVariant = 'thumb' | 'preview' | `export-${string}`;

export const storageKeys = {
  original: (userId: string, photoId: string, ext: string) => `originals/${userId}/${photoId}.${ext}`,
  originalsPrefix: (userId: string) => `originals/${userId}/`,
  derivative: (photoId: string, variant: DerivativeVariant) => `derivatives/${photoId}/${variant}.jpg`,
  derivativesPrefix: (photoId: string) => `derivatives/${photoId}/`,
  exportAlbum: (albumId: string, jobId: string) => `exports/${albumId}/${jobId}/album.pdf`,
  exportCover: (albumId: string, jobId: string) => `exports/${albumId}/${jobId}/cover.pdf`,
  exportPrefix: (albumId: string, jobId?: string) => (jobId ? `exports/${albumId}/${jobId}/` : `exports/${albumId}/`),
  flipbookPage: (albumId: string, jobId: string, n: number) => `flipbook/${albumId}/${jobId}/${n}.jpg`,
  flipbookPrefix: (albumId: string, jobId?: string) => (jobId ? `flipbook/${albumId}/${jobId}/` : `flipbook/${albumId}/`),
  font: (userId: string, fontId: string, ext: string) => `fonts/${userId}/${fontId}.${ext}`,
} as const;

/** Variant name for a DPI-sized, adjustment-baked export derivative. */
export const exportVariant = (hash: string): DerivativeVariant => `export-${hash}`;
